import type { RefObject } from 'react';
import { useEffect, useRef, useState } from 'react';
import type { Nilable } from '~/utilities/type-guards';
import { isNil } from '~/utilities/type-guards';

const TIMEOUT_MS = 1200;
const SCALE_FACTOR = 0.9;

type Props = {
  letterboxColor: Nilable<string>;
  playerRef: RefObject<HTMLDivElement | null>;
  letterboxRef: RefObject<HTMLDivElement | null>;
};

export const usePreviewLetterboxColor = ({
  letterboxColor,
  playerRef,
  letterboxRef,
}: Props): void => {
  const [letterboxColorFromProps, _] = useState<Nilable<string>>(letterboxColor);

  const timeoutId = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (isNil(letterboxColor) || isNil(playerRef.current) || isNil(letterboxRef.current)) {
      return;
    }

    if (letterboxColorFromProps === letterboxColor) {
      return;
    }

    const player = playerRef.current;
    const letterboxWidth = letterboxRef.current.clientWidth;

    if (player.clientWidth < letterboxWidth && isNil(timeoutId.current)) {
      return;
    }

    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }

    timeoutId.current = setTimeout(() => {
      player.style.maxWidth = '80vw';
    }, TIMEOUT_MS);

    player.style.maxWidth = `${letterboxWidth * SCALE_FACTOR}px`;
  }, [letterboxColor, playerRef, letterboxRef, letterboxColorFromProps]);
};
